// Keep this module free of Next/browser imports so session policy can be tested directly.
export const PROVIDER_REFRESH_TOKEN_TTL_SECONDS = 30 * 24 * 60 * 60

export function hasProviderRole(roles: unknown): boolean {
  return (
    Array.isArray(roles) &&
    roles.some((role) => ['doctor', 'superadmin', 'support'].includes(role))
  )
}

export function isProviderSessionId(value: unknown): value is string {
  return typeof value === 'string' && /^[a-f0-9]{32}$/.test(value)
}

export function providerRefreshTokenKey(sessionId: string): string {
  if (!isProviderSessionId(sessionId))
    throw new Error('Invalid provider session identifier')
  return `provider-auth-session:${sessionId}:refresh-token`
}

/** Send activity immediately, then at most once every 30 seconds while input continues.
 * There is deliberately no heartbeat timer, mount event, or focus event that extends a session.
 */
export function createProviderActivityReporter(
  report: () => void,
  now: () => number = Date.now,
) {
  let lastReportedAt = -Infinity
  return (event: { isTrusted: boolean }, visible: boolean) => {
    if (!event.isTrusted || !visible) return
    const timestamp = now()
    if (timestamp - lastReportedAt < 30_000) return
    lastReportedAt = timestamp
    report()
  }
}
